var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { orderBy } from 'lodash';
import moment from 'moment';
export var getters = {
    getJob: function (state) { return function (jobId) { return state.jobs.find(function (j) { return j.id === jobId; }); }; },
    getCandidatesForPipelineStage: function (state) {
        return function (stage, resultScreenFilters, queryFilters) {
            if (!state.candidates) {
                return [];
            }
            var availableCandidates = state.candidates.filter(function (candidate) {
                var _a;
                var filteredAttribute = state.job.version === 2 ?
                    candidate.category :
                    (_a = candidate.formResult) === null || _a === void 0 ? void 0 : _a.identifier;
                return candidate.pipelineStage === stage.id
                    && (!(resultScreenFilters === null || resultScreenFilters === void 0 ? void 0 : resultScreenFilters.length) || resultScreenFilters.includes(filteredAttribute));
            });
            if (queryFilters) {
                availableCandidates = availableCandidates.filter(function (candidate) { return queryFilters.talentId.some(function (id) { return id === candidate.talent.id; }); });
            }
            return orderBy(availableCandidates, [function (candidate) { return (candidate.category === 0 ? Number.MAX_VALUE : candidate.category); }, function (candidate) { return moment(candidate.createdAt).unix(); }], ['asc', 'asc']);
        };
    },
    resultScreens: function (state) { return function (stageId) {
        var _a;
        if (!state.candidates) {
            return [];
        }
        if (state.job.version === 2) {
            var categoryMap_1 = {
                0: '?',
                1: 'A+',
                2: 'A',
                3: 'B',
                4: 'C',
            };
            var candidates = stageId ? state.candidates.filter(function (candidate) { return candidate.pipelineStage === stageId; }) : state.candidates;
            var filterSet_1 = candidates.reduce(function (filters, candidate) {
                var identifier = candidate.category;
                if (!filters[identifier]) {
                    filters[identifier] = {
                        identifier: identifier,
                        label: categoryMap_1[identifier],
                        titles: [],
                    };
                }
                return filters;
            }, {});
            var resultScreens = Object.values(filterSet_1).sort(function (a, b) { return (a.identifier > b.identifier ? 1 : -1); });
            if (((_a = resultScreens[0]) === null || _a === void 0 ? void 0 : _a.identifier) === 0) {
                var first = resultScreens[0], rest = resultScreens.slice(1);
                resultScreens = __spreadArray(__spreadArray([], rest), [first]);
            }
            return resultScreens;
        }
        var filterSet = state.candidates.reduce(function (filters, candidate) {
            var _a;
            var identifier = (_a = candidate.formResult) === null || _a === void 0 ? void 0 : _a.identifier;
            if (!filters[identifier]) {
                filters[identifier] = { identifier: identifier, label: identifier, titles: [] };
            }
            if (identifier && !filters[identifier].titles.includes(candidate.formResult.title)) {
                filters[identifier].titles.push(candidate.formResult.title);
            }
            return filters;
        }, {});
        return Object.values(filterSet).sort(function (a, b) { return ((a.identifier) ? a.identifier.localeCompare(b.identifier) : 1); });
    }; },
    allFiltersActive: function (state, getters) { return state.resultScreenFilters.length === getters.resultScreens('').length; },
    pipelineStages: function (s) { return s.job.stages; },
};
